module.exports = __webpack_public_path__ + "components/app-promo/static/en/snow-forecast__app-screenshot--3-628260f5f92c092251932c7bcc4acbf1.jpg";